import React, { Component } from "react";
import { Grid as Container, Row, Col } from "react-bootstrap";
import _ from "lodash";
import Card from "components/Card/Card.jsx";
//import Button from "components/CustomButton/CustomButton.jsx";
import { Button, ButtonToolbar, Modal } from "react-bootstrap";

import Chart from "../../components/Charts/chart";

class Typography extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    timeButtons: [
      {
        value: 3600,
        descr: "1 godzina",
        active: false
      },
      {
        value: 86400,
        descr: "1 dzień",
        active: false
      },
      {
        value: 172800,
        descr: "2 dni",
        active: true
      },
      {
        value: 604800,
        descr: "Tydzień",
        active: false
      },
      {
        value: 1209600,
        descr: "2 tygodnie",
        active: false
      },
      {
        value: 2419200,
        descr: "Miesiąc",
        active: false
      }
      // {
      //   value: 7948800,
      //   descr: "3 Miesiące",
      //   active: false
      // },
      // { value: 9638400, descr: "Rok", active: false }
    ],
    chartType: [
      {
        value: 1,
        descr: "Mleko",
        active: true
      },
      {
        value: 2,
        descr: "Temperatura",
        active: false
      }
    ],
    activeDevice: this.props.device[0].id,
    activeChartType: 1,
    activeTimeButton: 172800,
    activeDeviceName: "",
    showModal: false,
    tempActiveChartType: 1,
    tempActiveTimeButton: 172800,
    tempActiveDevice: 0,
    renderChart: true,
    activeTimeButtonDescr: ""
  };

  handleClose() {
    var tempActiveDeviceName;
    this.props.device.map(device => {
      if (this.state.tempActiveDevice === device.id)
        tempActiveDeviceName = device.desc;
    });

    var tempActiveTimeButtonDescr;
    this.state.timeButtons.map(button => {
      if (button.active) tempActiveTimeButtonDescr = button.descr;
    });
    this.setState({
      renderChart: true,
      showModal: false,
      activeTimeButton: this.state.tempActiveTimeButton,
      activeChartType: this.state.tempActiveChartType,
      activeDevice: this.state.tempActiveDevice,
      activeDeviceName: tempActiveDeviceName,
      activeTimeButtonDescr: tempActiveTimeButtonDescr
    });
  }

  handleShow() {
    this.setState({ showModal: true, renderChart: false });
  }

  componentDidMount() {
    if (this.props.device.length) {
      var tempActiveDeviceName;
      this.props.device.map(device => {
        if (this.state.activeDevice === device.id)
          tempActiveDeviceName = device.desc;
      });

      var tempActiveTimeButtonDescr;
      this.state.timeButtons.map(button => {
        if (button.active) tempActiveTimeButtonDescr = button.descr;
      });

      this.setState({
        tempActiveDevice: this.props.device[0].id,
        activeDeviceName: tempActiveDeviceName,
        activeTimeButtonDescr: tempActiveTimeButtonDescr
      });
    }
  }

  buttonClick = button => {
    //console.log(button);
    let index = _.findIndex(this.state.timeButtons, button);
    let newTimeButtons = _.forEach(this.state.timeButtons, function(button) {
      button.active = false;
    });
    newTimeButtons[index].active = true;
    this.setState({
      timeButtons: newTimeButtons,
      tempActiveTimeButton: this.state.timeButtons[index].value
    });
  };
  getDeviceDescr = device => {};

  deviceChange = device => {
    //console.log(button);

    this.setState({ tempActiveDevice: device.id });
  };

  buttonClick2 = button => {
    // console.log(button);
    let index = _.findIndex(this.state.chartType, button);
    let newChartType = _.forEach(this.state.chartType, function(button) {
      button.active = false;
    });
    newChartType[index].active = true;
    this.setState({
      chartType: newChartType,
      tempActiveChartType: this.state.chartType[index].value
    });
  };

  render() {
    var category = "";
    var category =
      (this.state.activeChartType === 1 && "Ilość mleka") ||
      (this.state.activeChartType === 2 && "Temperatura");
    category += " - " + this.state.activeTimeButtonDescr;

    return (
      <div className="content">
        <Container fluid>
          <Row>
            <Col>
              <Modal
                show={this.state.showModal}
                onHide={() => this.handleClose()}
              >
                <Modal.Header closeButton>
                  <Modal.Title className="text-center">
                    Opcje wykresu
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Card
                    content={
                      <Container fluid>
                        <Row>
                          <Col className="text-center">
                            <span>
                              <h5>Urządzenie</h5>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <ButtonToolbar>
                              <Row>
                                {this.props.device.map(device => {
                                  return (
                                    <Col sm={6} key={device.id}>
                                      <Button
                                        block
                                        className="align-middle"
                                        style={{ margin: 5 }}
                                        key={device.id}
                                        size="sm"
                                        bsStyle={
                                          this.state.tempActiveDevice ===
                                          device.id
                                            ? "primary"
                                            : "default"
                                        }
                                        onClick={() =>
                                          this.deviceChange(device)
                                        }
                                      >
                                        {device.desc}
                                      </Button>
                                    </Col>
                                  );
                                })}
                              </Row>
                            </ButtonToolbar>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="text-center">
                            <span>
                              <h5>Zakres danych</h5>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <ButtonToolbar>
                              <Row>
                                {this.state.timeButtons.map(button => {
                                  return (
                                    <Col xs={6} md={4} key={button.value}>
                                      <Button
                                        block
                                        style={{ margin: 5 }}
                                        key={button.value}
                                        size="lg"
                                        bsStyle={
                                          button.active ? "primary" : "default"
                                        }
                                        onClick={() => this.buttonClick(button)}
                                      >
                                        {button.descr}
                                      </Button>
                                    </Col>
                                  );
                                })}
                              </Row>
                            </ButtonToolbar>
                          </Col>
                        </Row>
                        <Row>
                          <Col className="text-center">
                            <span>
                              <h5>Rodzaj wykresu</h5>
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <ButtonToolbar>
                              <Row>
                                {this.state.chartType.map(button => {
                                  return (
                                    <Col xs={6} key={button.value}>
                                      <Button
                                        block
                                        key={button.value}
                                        style={{ margin: 5 }}
                                        size="sm"
                                        bsStyle={
                                          button.active ? "primary" : "default"
                                        }
                                        onClick={() =>
                                          this.buttonClick2(button)
                                        }
                                      >
                                        {button.descr}
                                      </Button>
                                    </Col>
                                  );
                                })}
                              </Row>
                            </ButtonToolbar>
                          </Col>
                        </Row>
                      </Container>
                    }
                  />
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" onClick={() => this.handleClose()}>
                    Zastosuj
                  </Button>
                </Modal.Footer>
              </Modal>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card
                title={this.state.activeDeviceName}
                category={category}
                content={
                  <div>
                    <div className="text-center">
                      <Button bsStyle="info" onClick={() => this.handleShow()}>
                        Ustawienia wykresu
                      </Button>
                    </div>
                    <Chart
                      activeChart={this.state.activeChartType}
                      activeTimeButton={this.state.activeTimeButton}
                      activeDevice={this.state.activeDevice}
                      renderChart={this.state.renderChart}
                    />
                  </div>
                }
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Typography;



// WEBPACK FOOTER //
// ./src/views/Charts/Charts.jsx